<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <ng-container *ngTemplateOutlet="info"></ng-container>
        <ng-container *ngTemplateOutlet="buttons"></ng-container>
    </tt-card>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_info">
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="h_functions">
            <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </tt-card>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!menu">
        <tt-input ttLabel="travelwageset_keyno" [ttModel]="menu.travelwageset_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="travelwageset_name" [ttModel]="menu.travelwageset_name" ttReadonly></tt-input>
        <tt-datetime ttLabel="valid_fom_dt" [ttModel]="menu.valid_fom_dt" ttReadonly></tt-datetime>
    </ng-container>
</ng-template>

<ng-template #buttons>
    <ng-container *ngIf="!!menu">
        <tt-button-goto [ttText]="'travelwagesetmenu_edit'" [ttGoto]="'travelwageset'" [ttGotoParms]="{ travelwageset_keyno: menu.travelwageset_keyno }"></tt-button-goto>
        <tt-button-goto [ttText]="'travelwagesetrates_rates'" [ttGoto]="'travelwagesetrates'" [ttGotoParms]="{ travelwageset_keyno: menu.travelwageset_keyno }"></tt-button-goto>
    </ng-container>
</ng-template>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-3 sp-5">
        <tt-input class="col-xs-12 sp-0" tt-label="travelwageset_keyno" tt-model="vm.model.menu.travelwageset_keyno" tt-change="vm.model.menu.travelwageset_keyno = $value" tt-readonly="true"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="travelwageset_name" tt-model="vm.model.menu.travelwageset_name" tt-change="vm.model.menu.travelwageset_name = $value" tt-readonly="true"></tt-input>
        <tt-datetime class="col-xs-12 sp-0" tt-label="valid_fom_dt" tt-model="vm.model.menu.valid_fom_dt" tt-change="vm.model.menu.valid_fom_dt = $value" tt-date-options="{ date: {show: true, disabled: false, align: 'right'}, hour: {show: true, disabled: false, align: 'right'}, minute: {show: true, disabled: false, align: 'right', interval: 1}}" tt-readonly="true"></tt-datetime>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="travelwagesetmenu_edit" tt-goto="travelwageset" tt-goto-parms="{ travelwageset_keyno: vm.model.menu.travelwageset_keyno }" tt-text-align="left"></tt-button-goto>
        <tt-button-goto class="col-xs-12 sp-0" tt-text="travelwagesetrates_rates" tt-goto="travelwagesetrates" tt-goto-parms="{ travelwageset_keyno: vm.model.menu.travelwageset_keyno }" tt-text-align="left"></tt-button-goto>
    </tt-card>
</tt-page>-->
